import script from "./LegendBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegendBox.vue?vue&type=script&setup=true&lang=ts"

import "./LegendBox.vue?vue&type=style&index=0&id=3fff00a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fff00a3"]])

export default __exports__